import { render } from "./workspace-settings-sidebar.vue?vue&type=template&id=5906710f"
import script from "./workspace-settings-sidebar.vue?vue&type=script&lang=js"
export * from "./workspace-settings-sidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__